module.exports = __webpack_public_path__ + "7d0b464f4eaebffea27fa0dc38f7eff8.webm";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video/key-art-1080.webm
// module id = 637
// module chunks = 0